// ---------------------------------------------------------------------------
// Faixa "Instalar app" — uma única memória para o app inteiro.
//  · "Agora não" vale 7 dias (localStorage), não só a sessão.
//  · Quando o cartão "Coloque na tela do celular" está visível na carteira,
//    a faixa do topo fica calada (nunca dois convites na mesma tela).
// Se o armazenamento falhar, nada quebra: só esquece o adiamento.
// ---------------------------------------------------------------------------

import { useSyncExternalStore } from 'react';

const CHAVE_FAIXA = 'seliga:faixa_instalar_fechada';
const CHAVE_CADASTRO = 'seliga:cadastro_depois_ate';
const DIAS_FAIXA = 7;
const HORAS_CADASTRO = 24;

export function faixaFechada(): boolean {
  try {
    const ate = Number.parseInt(localStorage.getItem(CHAVE_FAIXA) || '0', 10) || 0;
    return Date.now() < ate;
  } catch {
    return false;
  }
}

export function fecharFaixa(): void {
  try {
    localStorage.setItem(CHAVE_FAIXA, String(Date.now() + DIAS_FAIXA * 24 * 3600 * 1000));
  } catch {
    // ignorado
  }
}

export function cadastroAdiado(): boolean {
  try {
    const ate = Number.parseInt(localStorage.getItem(CHAVE_CADASTRO) || '0', 10) || 0;
    return Date.now() < ate;
  } catch {
    return false;
  }
}

export function adiarCadastro(): void {
  try {
    localStorage.setItem(
      CHAVE_CADASTRO,
      String(Date.now() + HORAS_CADASTRO * 3600 * 1000),
    );
  } catch {
    // ignorado
  }
}

// ---------------------------------------------------------------------------
// "Tem um convite de instalar já na tela?" — a carteira avisa quando o cartão
// dela está visível, e a faixa do topo se cala.
// ---------------------------------------------------------------------------

let conviteNaTela = false;
const ouvintes = new Set<() => void>();

export function marcarConviteNaTela(visivel: boolean): void {
  if (conviteNaTela === visivel) return;
  conviteNaTela = visivel;
  ouvintes.forEach((fn) => fn());
}

function inscrever(ouvinte: () => void): () => void {
  ouvintes.add(ouvinte);
  return () => {
    ouvintes.delete(ouvinte);
  };
}

function ler(): boolean {
  return conviteNaTela;
}

/** Lê (e acompanha) se algum convite já está ocupando a tela. */
export function useConviteNaTela(): boolean {
  return useSyncExternalStore(inscrever, ler, () => false);
}